export enum WorkflowStatus {
    Draft = 'draft',
    Ready = 'ready',
    Updating = 'updating',
    Deprecated = 'deprecated',
    Suspended = 'suspended',
}
